// extracted by mini-css-extract-plugin
module.exports = {"sociometryDeleteModal":"SociometryDeleteModal_sociometryDeleteModal__26m30","closeButton":"SociometryDeleteModal_closeButton__2eBhy"};